import { clsx } from 'clsx';
import React from 'react';
import classes from './VisuallyHidden.module.css.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import Box from '../Box/Box.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

/**
 * Provides a component that implements the "visually hidden" technique. This is
 * analagous to the common `sr-only` class. Children that are rendered inside
 * this component will not be visible but will be available to screen readers.
 *
 * Note: if this component, or a descendant, has focus then this component will
 * no longer be visually hidden.
 *
 * @see https://www.scottohara.me/blog/2023/03/21/visually-hidden-hack.html
 */
const VisuallyHidden = ({
  className,
  children,
  sx: sxProp = defaultSxProp,
  ...rest
}) => {
  if (sxProp !== defaultSxProp) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      sx: sxProp,
      className: clsx(className, classes.VisuallyHidden)
    }, rest), children);
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    className: clsx(className, classes.VisuallyHidden)
  }, rest), children);
};
VisuallyHidden.displayName = "VisuallyHidden";

export { VisuallyHidden };
